export default "__VITE_ASSET__BTcXAG1A__"